import { Skeleton } from '@/shared/ui/skeleton'
import { cn } from '@/utils/cn'
import { HTMLAttributes } from 'react'
export type ProductThumbnailPendingProps = {}

export const ProductThumbnailPending = ({
  className,
  ...props
}: ProductThumbnailPendingProps & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn(
        'relative flex aspect-square w-full justify-center md:aspect-auto',
        className,
      )}
      {...props}
    >
      <div className="size-full bg-gray-200 md:relative md:size-[536px]">
        <Skeleton className="size-full" />
      </div>
    </div>
  )
}
